<template>
  <carousel :dots="true" ref="carouselCursosHome">
      <carousel-item v-for="curso in cursos" :key="curso.curso_id"
                     :titulo="curso.nome"
                     :imagem="urlImagem(curso.imagem_capa)"
                     texto-url="continuar curso"
                     :url="curso.url"
                     :progresso="curso.progresso"
                     :dataExpiracao="curso.dataExpiracao"
                     :continuarAssistindo="true" />
  </carousel>
</template>

<script>
import CarouselItem from '@/core/components/CarouselItem'
import Carousel from '@/core/components/Carousel'
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'MeusCursosHomeCarousel',
  components: { Carousel, CarouselItem },
  props: {
    cursos: Array
  },
  methods: {
    applyOwlCarousel: function () {
      this.$refs.carouselCursosHome.applyOwlCarousel()
    },
    urlImagem: function (url) {
      return ImageUtils.obterUrlCompletaImagem(url, 'cursos-plataforma/')
    }
  }
}
</script>

<style scoped>
</style>
